const content = document.getElementById("content-tabs");
const toggleButton = document.getElementById("toggleButton");

toggleButton.addEventListener("click", () => {
  if (content.style.maxHeight) {
    content.style.maxHeight = null;
    toggleButton.textContent = "Read More";
  } else {
    content.style.maxHeight = content.scrollHeight + "px";
    toggleButton.textContent = "Read Less";
  }
});
